/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import {
    onKeyBackExitConfirmationOverlay,
    onKeyOkExitConfirmationOverlay,
    onMouseClickExitConfirmationOverlay,
    showExitConfirmationOverlayDialog,
} from '../overlay/exitconfirmationoverlay/exitconfirmationoverlay.reducers';
import {
    hideNoNetworkOverlay,
    onMouseClickNoNetworkOverlay,
} from '../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import {
    onKeyDownOverlayDialog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../overlaydialog/overlaydialog.reducers';
import { setSignInButtonHighlightAction } from './signin.actions';
import {
    onKeyOkSignInDefaultOperations,
    onKeyOkSignInLpOperations,
    onKeyOkSignInOverlayOperations,
    onMouseClickSignInOverlayOperations,
} from './signin.reducers';

export const onKeyOkSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SIGN_IN_TASKS:
            dispatch(onKeyOkSignInDefaultOperations());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyOkExitConfirmationOverlay());
            break;

        case ScreenTaskControllerTypes.LP_CODE_EXPIRED_SIGNIN_TASK:
            dispatch(onKeyOkSignInLpOperations());
            break;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(hideNoNetworkOverlay());
            break;

        case ScreenTaskControllerTypes.SIGN_IN_ERROR_OVERLAY_TASKS:
            dispatch(onKeyOkSignInOverlayOperations());
            break;

        default:
            break;
    }
};

export const onKeyBackSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SIGN_IN_TASKS:
            dispatch(showExitConfirmationOverlayDialog());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyBackExitConfirmationOverlay());
            break;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(hideNoNetworkOverlay());
            break;

        case ScreenTaskControllerTypes.LP_CODE_EXPIRED_SIGNIN_TASK:
            dispatch(showExitConfirmationOverlayDialog());
            break;

        default:
            break;
    }
};

export const onKeyDownSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyDownOverlayDialog());
            break;

        default:
    }
};

export const onKeyUpSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyUpOverlayDialog());
            break;

        default:
    }
};

export const onMouseClickSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SIGN_IN_TASKS:
            dispatch(onKeyOkSignInDefaultOperations());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onMouseClickExitConfirmationOverlay());
            break;

        case ScreenTaskControllerTypes.LP_CODE_EXPIRED_SIGNIN_TASK:
            dispatch(onKeyOkSignInLpOperations());
            break;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onMouseClickNoNetworkOverlay());
            break;

        case ScreenTaskControllerTypes.SIGN_IN_ERROR_OVERLAY_TASKS:
            dispatch(onMouseClickSignInOverlayOperations());
            break;

        default:
            break;
    }
};

export const onMouseOverSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.SIGN_IN_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOverOverlayDialogOperations());
            break;

        case ScreenTaskControllerTypes.LP_CODE_EXPIRED_SIGNIN_TASK:
            dispatch(setSignInButtonHighlightAction(true));
            break;

        default:
            break;
    }
};

export const onMouseOutSignIn = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.LP_CODE_EXPIRED_SIGNIN_TASK:
            dispatch(setSignInButtonHighlightAction(false));
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY:
        case ScreenTaskControllerTypes.SIGN_IN_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOutOverlayDialogOperations());
            break;

        default:
            break;
    }
};
